import {useAccountInformationValue} from '@/auth/hooks/useAccountInformation'
import {getAddresses} from '@/lib/payment/paymentService'
import {NO_REFETCH_OPTIONS} from '@/utils/query/query'

export const getAddressesQueryKey = (accountId?: string | null) => ['addresses', accountId]

export function useAddresses() {
  const account = useAccountInformationValue()

  return useQuery({
    queryKey: getAddressesQueryKey(account?.id),
    queryFn: account ? getAddresses : skipToken,
    ...NO_REFETCH_OPTIONS,
  })
}
